import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import _ from 'lodash';

import profile from '../../../json/profile.json';
import Select from 'react-select';
import { Col, Grid, Row } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { getAllProducts } from "../../../redux/actions/product";
import {getProducts, setAutocompleteProducts} from "../../../redux/actions/product";
import ProductGeneralAutosuggest1 from "../../../app-components/Products/ProductGeneralAutosuggest/ProductGenerateAutosuggest1";
import TrackingService from '../../../services/TrackingService';

class ProfileAnalyseForm extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            nom: ''
        };
        this.props.getAllProducts();
        this.debounceGetProducts = _.debounce((filters) => this.props.getProducts(filters, true), 1000);
        this.lastResultStatus = null;
    }

    componentDidUpdate(prevProps) {
        // Track when analysis result changes (indicating a new analysis was performed)
        if (prevProps.result !== this.props.result && this.props.result.status !== null) {
            this.trackAnalysisResult();
        }
    }

    trackAnalysisResult = async () => {
        try {
            const isCI = this.props.result.status === 1;
            const analysisId = await TrackingService.trackAnalysis({
                analysisType: 'CONTRAINDICATION',
                medications: [],
                findingsCount: isCI ? 1 : 0,
                findings: [],
                riskLevel: isCI ? 'HIGH' : 'LOW',
                patientContext: {},
                responseTime: 0,
                cacheHit: false
            });
            if (analysisId) {
                await TrackingService.trackSave(analysisId, {
                    name: 'Analyse profil',
                    notes: 'Analyse de contre-indication médicament-profil'
                });
                await TrackingService.trackConsultation(analysisId, 5);
            }
        } catch (e) {}
    };
    setValue = (val, index) => {
        let newState = {};
        // S'assurer que val est toujours une string pour éviter l'erreur .trim()
        newState[index] = val != null ? String(val) : '';
        this.setState(newState);
    };
    stateProfile = {
        profiles : null
    };

    stateProduct = {
        product : null
    };

    chooseStatus(status){

        switch (status) {
            case null:
                return {bg: "#F5F5F5", col: '#536878' }
            case 0:
                return {bg: "#FFF5FE", col: '#DC143C' }
            case 1:
                return {bg: "#FEFEFA", col: '#FF7E00' }
            case -1:
                return {bg: "#FEFEFA", col: '#03C03C' }
            default:
                break;
        }
    }

    render() {
        return (
            <div className="main-content" >
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content=
                                {
                                    <Grid fluid>
                                        <h3 className="text-center">
                                            <strong>Veuillez renseignez les informations nécessaires pour l'analyse de contre-indication médicament-profil !</strong>
                                        </h3>
                                        <br></br>
                                        <div className="col-md-12">
                                            <div className="col-md-6">
                                        <ProductGeneralAutosuggest1
                                            value={this.state.nom}
                                            onChange={(e) => this.setValue(e.target.value, 'nom')}
                                            addTag={(val) => {this.props.onChangeProduct({ label: val.nom, value: val._id, profilesContreIndiquees: val.profilesContreIndiquees || '' }); this.setState({'nom': val['nom'], 'id': val['_id']})}}
                                            suggestions={this.props.autocompleteProducts}
                                            placeholder="Nom commercial"
                                            clearSuggestions={() => this.props.setAutocompleteProducts([])}
                                            getSuggestions={(val) => this.debounceGetProducts({nom: val, DCI: '', familleTherapeutique: '', classesPharmacologiques: '', dosage: '', forme: ''})}
                                            style={{width: '100%'}}
                                            formControl
                                            nameColumn="nom"
                                        />
                                            </div>
                                            <div className="col-md-6">
                                                <Select
                                                    options={profile.sort((a, b) => {  
                                                        return a.profile >= b.profile ? 1 : -1}).map(pro => ({ label: pro.profile, value: pro.profile }))}
                                                    placeholder={'Profil'}
                                                    onChange={this.props.onChangeProfile}
                                                />
                                            </div>
                                        </div>
                                    </Grid>
                                }
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card  background='secondary'                    
                                content=
                                {
                                    <div className="text-center"  
                                         style={{ height: '100%', backgroundColor: this.chooseStatus(this.props.result.status).bg}}>
                                        <p className="text-center" 
                                           style={{paddingTop: '2px', fontSize: '30px', color: this.chooseStatus(this.props.result.status).col}}>
                                            {this.props.result.data}
                                        </p>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                    <div className="text-center">
                        <Button bsStyle="info" fill type="submit" style={{fontSize:"2rem"}}>
                             Lancer l'analyse
                        </Button>
                    </div>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        products: state.products.products,
        loading: state.status.loading,
        autocompleteProducts: state.products.autocompleteProducts
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getAllProducts: filter => {
            dispatch(getAllProducts(filter));
        },
        getProducts: (filter, autocomplete) => {
            dispatch(getProducts(filter, autocomplete));
        },
        setAutocompleteProducts: products => {
            dispatch(setAutocompleteProducts(products));
        }
    }
};
ProfileAnalyseForm.propTypes = {
    loading: PropTypes.bool,
    autocompleteProducts: PropTypes.array,

    getProducts: PropTypes.func,
    setAutocompleteProducts: PropTypes.func,
    showNotification: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAnalyseForm);
